import { Tooltip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import dayjs from "dayjs";
import React from "react";

const useStyles = makeStyles({
	root: {
		minWidth: "100%"
	},
	table: {
		minWidth: "500px"
	}
});


export default function Info({ vehicle }) {
	const classes = useStyles();

	let signal = "Unavailable";
	if (vehicle.tracker.status[0]?.signal) {
		signal = vehicle.tracker.status[0].signal;
		if (vehicle.tracker.model.includes('FM')) {
			signal += "/5"
		} else if (vehicle.tracker.model.includes('TZ')) {
			signal += "/31"
		} else if (vehicle.tracker.model.includes('Edge')) {
			signal = `-${signal}dBm`
		}
	}

	const isEdge = vehicle.tracker.model.includes('Edge');

	let temperature = "Unavailable";

	if (vehicle.tracker.status[0]?.io?.temperature) {
		temperature = `${vehicle.tracker.status[0]?.io?.temperature}°C`
	}

	return (
		<TableContainer className={classes.root}>
			<Table className={classes.table} size="small" aria-label="a dense table">
				<TableBody>
					<TableRow key={"address"}>
						<TableCell colSpan={2} align="left">
							<b>{`Address: `}</b>
							{vehicle.tracker.status[0].address}
						</TableCell>
					</TableRow>
					<TableRow key={"last-signal"}>
						<TableCell align="left">
							<b>{`Last Signal: `}</b>
							{`${dayjs(vehicle.tracker.status[0].position_timestamp).format('DD-MM-YYYY HH:mm:ss')}`}<br />
							{` ${Intl.DateTimeFormat().resolvedOptions().timeZone}`}
							{vehicle?.tracker?.status[0]?.position_timestamp ? ` (${dayjs(vehicle?.tracker?.status[0]?.position_timestamp).fromNow()})` : ''}
						</TableCell>
						<TableCell align="left">
							<b>{`Serial: `}</b>
							{vehicle.tracker.serial}
						</TableCell>
					</TableRow>
					{!isEdge && <TableRow key={"inginition-serial"}>
						<TableCell align="left">
							<b>{`Ignition: `}</b>
							{vehicle.tracker.status[0].io.ignition ? "ON" : "OFF"}
						</TableCell>
						{vehicle?.tracker?.serial.length > 9 && <TableCell align="left">
							<b>{`Immobilised: `}</b>
							{vehicle.tracker.status[0].io.immobilised ? "Locked" : "Unlocked"}
						</TableCell>}
					</TableRow>}
					{!isEdge && <TableRow key={"kms-speed"}>
						<TableCell align="left">
							<b>{`Vehicle Odometer: `}</b>
							{vehicle.odometer}
						</TableCell>
						<TableCell align="left">
							<b>{`Satellites: `}</b>
							{vehicle.tracker.status[0].satellites}
						</TableCell>
					</TableRow>}
					<TableRow key={"temp-driver"}>
						<TableCell align="left" >
							<b>{`Temperature: `}</b>
							{temperature}
						</TableCell>
						<TableCell align="left" >
							<b>{`Internal Battery: `}</b>
							{vehicle.tracker.status[0]?.io?.battery} V
						</TableCell>
					</TableRow>
					{!isEdge && <TableRow key={"int-ext-batt"}>
						<TableCell align="left">
							<b>{`Speed: `}</b>
							{vehicle.tracker.status[0].speed}
						</TableCell>
						<TableCell align="left">
							<b>{`External Battery: `}</b>
							{vehicle.tracker.status[0]?.io?.vehicle_voltage} V
						</TableCell>
					</TableRow>}
					{!isEdge && <TableRow key={"fuel"}>
						<TableCell align="left" >
							<b>{`Fuel(Liters): `}</b>
							{vehicle.tracker.status[0]?.io?.fuelL ? `${vehicle.tracker.status[0]?.io?.fuelL}L/${vehicle.fuelcapacity}L` : 'Unavailable'}
						</TableCell>
						<TableCell align="left">
							<b>{`Fuel(%): `}</b>
							{vehicle.tracker.status[0]?.io?.fuelP ? `${vehicle.tracker.status[0]?.io?.fuelP}%` : 'Unavailable'}
						</TableCell>
					</TableRow>}
					<TableRow key={"signal"}>
						<TableCell align="left" colSpan={1}>
							<b>{`Model: `}</b>
							{vehicle.tracker.model}
						</TableCell>
						<TableCell align="left" colSpan={1}>
							<b>{`Signal: `}</b>
							{signal}
						</TableCell>
					</TableRow>
					<TableRow key={"model"}>
					</TableRow>
					{vehicle.tracker.model.includes("Edge") && <TableRow key={"accuracy"}>
						<TableCell align="left" colSpan={2}>
							<b>{`Accuracy(m): `}</b>
							{vehicle.tracker.status[0]?.accuracy}
						</TableCell>
					</TableRow>}
				</TableBody>
			</Table>
		</TableContainer>
	);
}
